export default "__VITE_ASSET__c2c67700__"